import { css } from 'linaria';

export const signupBlockTitle = css`
  margin-bottom: 16px;

  @media (--only-mobile) {
    margin-bottom: 10px
  }
`;

export const signupBlockHide = css`
  &&& {
    @media (--from-tablet) {
      right: -100%;
    }

    @media (--only-mobile) {
      left: -100%;
    }
  }
`;

export const signupBlock = css`
  display: flex;
  border-radius: var(--rounding-xl);
  background-color: var(--background-primary);
  position: absolute;
  right: 32px;
  top: 50%;
  transform: translate(0, -50%);
  height: 382px;
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);

  @media (--only-tablet) {
    right: 16px;
  }

  @media (--only-mobile) {
    bottom: 16px;
    left: 50%;
    top: unset;
    transform: translate(-50%, 0);
    height: fit-content;
    width: 256px;
    transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;

export const fullWidthBgImage = css`
  width: 100%;

  @media (--only-mobile) {
    height: 590px;
    object-fit: cover;
  }
`;

export const imageWrapper = css`
  position: relative;
  overflow: hidden;
`;

export const bgImage = css`
  width: 100%;
  border-radius: var(--rounding-xl);
  height: 497px;
  object-fit: cover;

  @media (--only-desktop) {
    height: 448px;
  }

  @media (--only-tablet) {
    height: 415px;
  }

  @media (--only-mobile) {
    height: 590px;
  }
`;

export const layout = css`
  transition: width 0.5s ease-in-out, padding 0.5s ease-in-out;
`;

export const fullWidthLayout = css`
  width: 100%;
  padding: 0;
`;

export const signupBlockBody = css`
  width: 382px;
  padding: 32px;
  border-radius: var(--rounding-xl);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (--only-tablet) {
    width: 314px;
  }

  @media (--only-mobile) {
    width: 100%;
    padding: 20px;
  }
`;

export const signupBlockBodyWrapper = css`
  @media (--only-mobile) {
    margin-bottom: 16px;
  }
`;
